import React from 'react';
const Dashboard = React.lazy(() => import('./Dashboard'));
export const inicioPagesConfigs = [
  {
    // permittedPath: RoutePermittedPath.dashboard,
    path: '/inicio',
    element: <Dashboard />,
  },
];
